import { render, staticRenderFns } from "./UsersListView.vue?vue&type=template&id=2cd386a8&"
import script from "./UsersListView.vue?vue&type=script&lang=js&"
export * from "./UsersListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports